import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { NASIOL, adsFactors } from '../nasiolContent';

const AdsFactors = () => (
  <Box
    component="section"
    id="como-cotizamos"
    py={{ xs: 4, md: 5 }}
    px={{ xs: 2.5, sm: 4, md: 7 }}
    bgcolor={NASIOL.sand}
    borderBottom={`1px solid ${NASIOL.sandDeep}`}
  >
    <Box maxWidth={1100} mx="auto">
      <Typography
        sx={{
          fontFamily: '"Outfit", sans-serif',
          fontWeight: 700,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          fontSize: '0.7rem',
          color: NASIOL.lagoon,
          mb: 1,
        }}
      >
        {adsFactors.overline}
      </Typography>
      <Typography
        component="h2"
        sx={{
          fontFamily: '"Space Grotesk", "Outfit", sans-serif',
          fontWeight: 700,
          fontSize: { xs: '1.45rem', md: '1.75rem' },
          color: NASIOL.ink,
          mb: 2.5,
        }}
      >
        {adsFactors.title}
      </Typography>

      <Box
        display="flex"
        flexWrap="wrap"
        sx={{ gap: { xs: 1, md: 1.25 } }}
      >
        {adsFactors.items.map((item) => (
          <Box
            key={item.id}
            px={1.75}
            py={1}
            borderRadius={1.25}
            bgcolor={NASIOL.white}
            border={`1px solid ${NASIOL.sandDeep}`}
          >
            <Typography
              sx={{
                fontFamily: '"Outfit", sans-serif',
                fontWeight: 700,
                fontSize: { xs: '0.9rem', md: '0.95rem' },
                color: NASIOL.ink,
                whiteSpace: 'nowrap',
              }}
            >
              {item.title}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  </Box>
);

export default AdsFactors;
